import { W as WuiTooltip$1, d as defineCustomElement$1 } from './tooltip.js';

const WuiTooltip = WuiTooltip$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTooltip, defineCustomElement };

//# sourceMappingURL=wui-tooltip.js.map